"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.clearData = exports.setSortedPayments = exports.setClearAdyenData = exports.setPaymentMethod = exports.getAdyenPaymentMethods = exports.setPaymentWithTotals = exports.getPaymentMethods = exports.paymentMethodsSlice = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toolkit = require("@reduxjs/toolkit");
var _agent = require("@deosite/agent");
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var initialState = {
  availablePaymentMethodsMagento: null,
  sortedPayments: null,
  pickedPaymentMethod: null,
  adyenResponse: null,
  error: null,
  paymentTotals: null
};
var mapPaymentMethods = function mapPaymentMethods(paymentMethods) {
  var mappedPaymentMethods = paymentMethods.map(function (method) {
    return {
      id: method.code,
      label: method.title
    };
  });
  var freePayment = mappedPaymentMethods.filter(function (payment) {
    return payment.id === global.__appConfig__.paymentMethodFree;
  });
  return freePayment.length > 0 ? freePayment : mappedPaymentMethods;
};
var getPaymentMethods = (0, _toolkit.createAsyncThunk)("payment/getPaymentMethods", /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(arg) {
    var token, language, domain, cartId;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = arg.token, language = arg.language, domain = arg.domain, cartId = arg.cartId;
            if (!token) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", _agent.requests.get("/carts/mine/payment-information", false, token, {
              domain: domain,
              language: language
            }));
          case 3:
            return _context.abrupt("return", _agent.requests.get("/guest-carts/".concat(cartId, "/payment-information"), false, null, {
              language: language,
              domain: domain
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
exports.getPaymentMethods = getPaymentMethods;
var getAdyenPaymentMethods = (0, _toolkit.createAsyncThunk)("payment/getAdyenPaymentMethods", /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(arg) {
    var token, language, domain, cartId;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            token = arg.token, language = arg.language, domain = arg.domain, cartId = arg.cartId;
            if (!token) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", _agent.requests.post("/carts/mine/retrieve-adyen-payment-methods", {
              cart_id: cartId
            }, global.__appConfig__.adyenMagentoIntegrationToken, {
              language: language,
              domain: domain
            }));
          case 3:
            return _context2.abrupt("return", _agent.requests.post("/guest-carts/".concat(cartId, "/retrieve-adyen-payment-methods"), null, global.__appConfig__.adyenMagentoIntegrationToken, {
              language: language,
              domain: domain
            }));
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
exports.getAdyenPaymentMethods = getAdyenPaymentMethods;
var mappedPaymentTotals = function mappedPaymentTotals(totals) {
  return {
    shippingCost: totals.base_shipping_incl_tax,
    productsTotalPrice: totals.subtotal_incl_tax,
    discount: totals.discount_amount,
    cartTotalPrice: totals.base_grand_total,
    tax: totals.base_tax_amount
  };
};
var setPaymentWithTotals = (0, _toolkit.createAsyncThunk)("payment/getPaymentWithTotals", /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(arg) {
    var token, language, domain, cartId, body, url;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            token = arg.token, language = arg.language, domain = arg.domain, cartId = arg.cartId, body = arg.body;
            url = token ? global.__appConfig__.setPaymentGetTotalsCustomerUrl : (0, _createParametrizedUrl["default"])(global.__appConfig__.setPaymentGetTotalsGuestUrl, {
              cartId: cartId
            });
            _context3.next = 4;
            return _agent.requests.post(url, body, token, {
              language: language,
              domain: domain
            });
          case 4:
            return _context3.abrupt("return", _context3.sent);
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}());
exports.setPaymentWithTotals = setPaymentWithTotals;
var paymentMethodsSlice = (0, _toolkit.createSlice)({
  name: "paymentMethods",
  initialState: initialState,
  reducers: {
    setPaymentMethod: function setPaymentMethod(state, action) {
      state.pickedPaymentMethod = action.payload;
    },
    setClearAdyenData: function setClearAdyenData(state, action) {
      state.adyenResponse = null;
      state.sortedPayments = null;
    },
    setSortedPayments: function setSortedPayments(state, action) {
      state.sortedPayments = action.payload;
    },
    clearData: function clearData(state, action) {
      Object.keys(initialState).forEach(function (key) {
        state[key] = initialState[key];
      });
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getPaymentMethods.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(getPaymentMethods.fulfilled, function (state, action) {
      state.loading = false;
      state.availablePaymentMethodsMagento = action.payload.payment_methods ? mapPaymentMethods(action.payload.payment_methods) : [];
    });
    builder.addCase(getPaymentMethods.rejected, function (state, action) {
      state.loading = false;
      state.error = JSON.parse(action.error.message).message;
    });
    builder.addCase(getAdyenPaymentMethods.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(getAdyenPaymentMethods.fulfilled, function (state, action) {
      state.loading = false;
      var responseParsed = JSON.parse(action.payload);
      state.adyenResponse = responseParsed;
    });
    builder.addCase(getAdyenPaymentMethods.rejected, function (state, action) {
      state.loading = false;
      state.error = JSON.parse(action.error.message).message;
      state.adyenResponse = [];
    });
    builder.addCase(setPaymentWithTotals.pending, function (state) {
      state.loading = true;
      state.paymentTotals = null;
    });
    builder.addCase(setPaymentWithTotals.fulfilled, function (state, action) {
      state.loading = false;
      state.paymentTotals = mappedPaymentTotals(action.payload);
    });
    builder.addCase(setPaymentWithTotals.rejected, function (state, action) {
      state.loading = false;
      state.error = JSON.parse(action.error.message).message;
    });
  }
});
exports.paymentMethodsSlice = paymentMethodsSlice;
var _paymentMethodsSlice$ = paymentMethodsSlice.actions,
  setPaymentMethod = _paymentMethodsSlice$.setPaymentMethod,
  setClearAdyenData = _paymentMethodsSlice$.setClearAdyenData,
  setSortedPayments = _paymentMethodsSlice$.setSortedPayments,
  clearData = _paymentMethodsSlice$.clearData;
exports.clearData = clearData;
exports.setSortedPayments = setSortedPayments;
exports.setClearAdyenData = setClearAdyenData;
exports.setPaymentMethod = setPaymentMethod;
var _default = paymentMethodsSlice.reducer;
exports["default"] = _default;